import { USER_PERMISSIONS } from '@domain/user';

const {
  DOWNLOAD_BOOKING_PDF,
  EXPORT_BOOKINGS,
  EXPORT_PASS_HOLDERS,
  EXPORT_PREREGISTRATIONS,
  EXPORT_SALES_RECAP,
  READ_ANALYTICS,
  READ_BOOKING_DETAILS,
  READ_COMPANY_OFFERS,
  READ_COMPANY_SETTINGS,
  READ_CUSTOMERS,
  READ_DRAFT_EVENTS,
  READ_EVENTS,
  READ_EVENTS_REVENUE,
  READ_EVENTS_SOLD_ITEMS,
  READ_INSIGHTS,
  READ_MARKETING,
  READ_OFFERS,
  READ_OFFERS_QUANTITY,
  READ_PAST_EVENTS,
  READ_BOOKINGS,
  READ_REFUND_STATS,
  REFUND_BOOKING,
  RESEND_BOOKING_EMAIL,
  SHARE_EVENT_REPORT,
  WRITE_CLUBS,
  WRITE_BOX_OFFICE,
  WRITE_COMPANY_OFFERS,
  WRITE_COMPANY_SETTINGS,
  WRITE_EVENTS,
  WRITE_IMPORT_CSV,
  WRITE_INVITATIONS,
  WRITE_OFFLINE_SALES,
  MANAGE_USERS,
  READ_STATS,
  READ_PREREGISTRATIONS,
} = USER_PERMISSIONS;

export const ENABLED_INSIGHTS_ROUTE = [READ_INSIGHTS];
export const ENABLED_ANALYTICS_ROUTE = [READ_ANALYTICS];
export const ENABLED_MARKETING_ROUTE = [READ_MARKETING];
export const ENABLED_CUSTOMERS_ROUTE = [READ_CUSTOMERS];
export const ENABLED_COMPANY_OFFERS_ROUTE = [READ_COMPANY_OFFERS];
export const ENABLED_COMPANY_INFO_ROUTE = [READ_COMPANY_SETTINGS, WRITE_COMPANY_SETTINGS];
export const ENABLED_COMPANY_WIDGET_ROUTE = [WRITE_COMPANY_SETTINGS];
export const ENABLED_USERS_ROUTE = [MANAGE_USERS];
export const ENABLED_USERS_DETAIL_ROUTE = [MANAGE_USERS];
export const ENABLED_SIDEBAR_MENU_USERS_MANAGEMENT_BUTTON = [MANAGE_USERS];

export const ENABLED_EVENT_CREATE_INFO_ROUTE = [WRITE_EVENTS];
export const ENABLED_EVENT_EDIT_INFO_ROUTE = [WRITE_EVENTS];
export const ENABLED_EVENT_EDIT_DETAILS_ROUTE = [WRITE_EVENTS];
export const ENABLED_EVENT_OFFERS_ROUTE = [WRITE_EVENTS];
export const ENABLED_EVENT_PUBLISH_ROUTE = [WRITE_EVENTS];
export const ENABLED_DUPLICATE_EVENT_ROUTE = [WRITE_EVENTS];

export const ENABLED_PROCESS_IMPORT_CSV_ROUTE = [WRITE_IMPORT_CSV];
export const ENABLED_PROCESS_IMPORT_INVITATION_ROUTE = [WRITE_INVITATIONS];
export const ENABLED_PROCESS_IMPORT_OFFLINE_SALE_ROUTE = [WRITE_OFFLINE_SALES];
export const ENABLED_PROCESS_IMPORT_PASS_HOLDER_ROUTE = [WRITE_COMPANY_OFFERS];
export const ENABLED_BOOKING_DETAILS_ROUTE = [READ_BOOKING_DETAILS];

export const ENABLED_EVENT_STATS = [READ_EVENTS_REVENUE];
export const ENABLED_SOLD_ITEMS_BY_OFFER = [READ_EVENTS_SOLD_ITEMS];

export const ENABLED_EVENT_DRAFT_TAB = [READ_DRAFT_EVENTS];
export const ENABLED_EVENT_PAST_TAB = [READ_PAST_EVENTS];

export const ENABLED_REVENUE_FILTER = [READ_EVENTS_REVENUE];
export const ENABLED_BOOKING_SECTIONS = [READ_BOOKINGS];
export const ENABLED_REPORT_STATS = [READ_STATS];
export const ENABLED_REFUND_STATS = [READ_REFUND_STATS];
export const ENABLED_OFFER_TABLE_QUANTITY = [READ_OFFERS_QUANTITY];

export const ENABLED_CREATE_EVENT_BUTTON = [WRITE_EVENTS];
export const ENABLED_EDIT_EVENT_BUTTON = [WRITE_EVENTS];
export const ENABLED_DUPLICATE_EVENT_BUTTON = [WRITE_EVENTS];
export const ENABLED_CREATE_COMPANY_OFFERS_BUTTON = [WRITE_COMPANY_OFFERS];
export const ENABLED_SHOW_CUSTOM_FIELDS_SECTION = [READ_EVENTS, READ_OFFERS];

export const ENABLED_EXPORT_SALES_RECAP_BUTTON = [EXPORT_SALES_RECAP];
export const ENABLED_EXPORT_PASS_HOLDERS_BUTTON = [EXPORT_PASS_HOLDERS];
export const ENABLED_EXPORT_BOOKING_LIST_BUTTON = [EXPORT_BOOKINGS];
export const ENABLED_EXPORT_PREGISTRATION_LIST_BUTTON = [EXPORT_PREREGISTRATIONS];
export const ENABLED_PREREGISTRATION_TAB = [READ_PREREGISTRATIONS];
export const ENABLED_SHARE_EVENT_REPORT = [SHARE_EVENT_REPORT];

export const ENABLED_RESEND_EMAIL_BUTTON = [RESEND_BOOKING_EMAIL];
export const ENABLED_REFUND_BUTTON = [REFUND_BOOKING];
export const ENABLED_DOWNLOAD_BOOKING_PDF = [DOWNLOAD_BOOKING_PDF];

export const ENABLED_IMPORT_CSV_BUTTON = [WRITE_IMPORT_CSV];
export const ENABLED_INVITATIONS_BUTTON = [WRITE_INVITATIONS];
export const ENABLED_OFFLINE_SALES_BUTTON = [WRITE_OFFLINE_SALES];
export const ENABLED_BOX_OFFICE_BUTTON = [WRITE_BOX_OFFICE];

export const ENABLE_MENU_VENUE_OPTION_SETTINGS = [READ_COMPANY_SETTINGS];
export const ENABLE_MENU_VENUE_USER_MANAGEMENT_SETTINGS = [MANAGE_USERS];

export const ENABLED_ADD_VENUE = [WRITE_CLUBS];
